const locationSearch = typeof window !== 'undefined' ? window.location.search : '';

export const QUERY_VERSION = new URLSearchParams(locationSearch).get('version') ?? '2.0.0';
// eslint-disable-next-line
export const IS_TIER3_PAGE = !!new URLSearchParams(locationSearch).has('isdealer');
